export default {
  colors: {
    primary: '#3591FC',
    secondary: '#FFB753',
    tertiary: '#37517E',
    quaternary: '#E6EEFF',
    white: '#FFF',
    black: '#000',
    grey: '#888',
    lightGrey: '#ccc',
    darkGrey: '#333',
  },
  spacing: {
    xxs: '5px',
    xs: '10px',
    s: '15px',
    m: '20px',
    l: '25px',
    xl: '35px',
    xxl: '50px',
  },
  shadows: {
    bottom: '0px 3px 6px rgba(0, 0, 0, 0.16)',
    round: '0px 1px 6px rgba(0, 0, 0, 0.16)',
  },
};
